<template>
  <Modal
    :title="$t('create_warehouse')"
    modalId="create-modal"
    @submit="submitWarehouse"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitWarehouse" class="p-1">
      <!-- Warehouse Name -->
      <div class="mb-3">
        <label class="form-label fw-semibold">
          {{ $t('warehouse_name') }} <span class="text-danger">*</span>
        </label>
        <input type="text" v-model="warehouse.name" class="form-control" />
        <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
      </div>

      <!-- Address -->
      <div class="mb-3">
        <label class="form-label fw-semibold">
          {{ $t('warehouse_address') }}
        </label>
        <input type="text" v-model="warehouse.address" class="form-control" />
        <small v-if="errors.address" class="text-danger">{{ errors.address }}</small>
      </div>

      <!-- Phone -->
      <div class="mb-3">
        <label class="form-label fw-semibold">
          {{ $t('warehouse_phone_number') }}
        </label>
        <input type="text" v-model="warehouse.phone_number" class="form-control" />
        <small v-if="errors.phone_number" class="text-danger">
          {{ errors.phone_number }}
        </small>
      </div>

      <!-- General Error -->
      <div v-if="errorMessage" class="alert alert-danger py-2">
        {{ errorMessage }}
      </div>

    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue"; // Import Modal component
import apiUrls from "../../../urls";
import {useToast} from "vue-toastification";
import feather from "../../../../public/assets/js/feather.min";

export default {
   components: {
      Modal,
    },

   data() {
    return {
      warehouse: {
        name: '',
        address: '',
        phone_number: '',
      },
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {

      async submitWarehouse() {
        this.errors = {};  // Reset errors
        this.errorMessage = "";  // Reset general error message

        // Frontend validation
        if (!this.warehouse.name.trim()) this.errors.name = this.$t('error.required');

        // Phone number is optional but should be valid if entered
        if (this.warehouse.phone_number.trim()) {
          const phoneRegex = /^[0-9]{10,15}$/;
          if (!phoneRegex.test(this.warehouse.phone_number.trim())) {
            this.errors.phone_number = this.$t('error.invalid_phone');
          }
        }

        if (Object.keys(this.errors).length > 0) return; // Stop if validation fails

        try {
          const formData = new FormData();
          formData.append("name", this.warehouse.name);
          formData.append("address", this.warehouse.address);
          formData.append("phone_number", this.warehouse.phone_number);

          // Send API request
          const response = await this.$axios.post(apiUrls.inventory_warehouse.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.toast.success('Warehouse successfully created!')

          // Close modal after success
          const modal = document.getElementById("create-modal");
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) modalInstance.hide();

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }

          // Handle field-specific errors dynamically
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors; // Dynamically set field errors
          }
        }
      },
      resetForm() {
      // Reset form fields and errors
      this.warehouse = { id: null, name: '', address: '', phone_number: '' };
      this.errors = {};
      this.errorMessage = "";
    }
  },
};
</script>
